import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-deceased-details-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-deceased-details-cm.component.scss?ngResource";
import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component } from "@angular/core";
import { AppControllerService } from "../../../../app-controller.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { map, of } from "rxjs";
import { DeceasedNamesTableHeaderLookup, ViewDeceasedDetailsCmConstant } from "./view-deceased-details-cm.constants";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { LookupConstants } from "../../../../shared/constants/lookup.constants";
let ViewDeceasedDetailsCmComponent = class ViewDeceasedDetailsCmComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    appController;
    changeDetectorRefs;
    aflaModuleStrategyService;
    datePipe;
    selectedApplicationService;
    routerParamsService;
    nameControl = ViewDeceasedDetailsCmConstant.NAME_CONTROL;
    surnameControl = ViewDeceasedDetailsCmConstant.SURNAME_CONTROL;
    startDateControl = ViewDeceasedDetailsCmConstant.START_DATE_CONTROL;
    nameLabel = ViewDeceasedDetailsCmConstant.NAME_LABEL;
    surnameLabel = ViewDeceasedDetailsCmConstant.SURNAME_LABEL;
    startDateLabel = ViewDeceasedDetailsCmConstant.START_DATE_LABEL;
    sexLabel = ViewDeceasedDetailsCmConstant.SEX_LABEL;
    nationalityLabel = ViewDeceasedDetailsCmConstant.NATIONALITY_LABEL;
    maidenNameLabel = ViewDeceasedDetailsCmConstant.MAIDEN_NAME_LABEL;
    placeOfBirthLabel = ViewDeceasedDetailsCmConstant.PALCE_OF_BIRTH_LABEL;
    placeOfDeathLabel = ViewDeceasedDetailsCmConstant.PLACE_OF_DEATH_LABEL;
    provinceOfDeathLabel = ViewDeceasedDetailsCmConstant.PROVINCE_OF_DEATH_LABEL;
    identificationTypeLabel = ViewDeceasedDetailsCmConstant.IDENTITY_TYPE_LABEL;
    idNumberLabel = ViewDeceasedDetailsCmConstant.ID_PASSPORT_NUMBER_LABEL;
    dateOfDeathLabel = ViewDeceasedDetailsCmConstant.DATE_OF_DEATH_LABEL;
    dateOfBirthLabel = ViewDeceasedDetailsCmConstant.DATE_OF_BIRTH_LABEL;
    burialOrderNumberLabel = ViewDeceasedDetailsCmConstant.BURIAL_ORDER_LABEL;
    serialNumenerLabel = ViewDeceasedDetailsCmConstant.SERIAL_NUMBER_LABEL;
    verticalPositionLabel = ViewDeceasedDetailsCmConstant.VERTICAL_POSITION_LABEL;
    undertakerLabel = ViewDeceasedDetailsCmConstant.NAME_OF_THE_UNDERTAKER_LABEL;
    sexControl = ViewDeceasedDetailsCmConstant.SEX_CONTROL;
    nationalityControl = ViewDeceasedDetailsCmConstant.NATIONALITY_CONTROL;
    maidenNameControl = ViewDeceasedDetailsCmConstant.MAIDEN_NAME_CONTROL;
    placeOfBirthControl = ViewDeceasedDetailsCmConstant.PALCE_OF_BIRTH_CONTROL;
    placeOfDeathControl = ViewDeceasedDetailsCmConstant.PLACE_OF_DEATH_CONTROL;
    provinceOfDeathControl = ViewDeceasedDetailsCmConstant.PROVINCE_OF_DEATH_CONTROL;
    identificationTypeControl = ViewDeceasedDetailsCmConstant.IDENTITY_TYPE_CONTROL;
    idNumberControl = ViewDeceasedDetailsCmConstant.ID_PASSPORT_NUMBER_CONTROL;
    dateOfDeathControl = ViewDeceasedDetailsCmConstant.DATE_OF_DEATH_CONTROL;
    dateOfBirthControl = ViewDeceasedDetailsCmConstant.DATE_OF_BIRTH_CONTROL;
    burialOrderNumberControl = ViewDeceasedDetailsCmConstant.BURIAL_ORDER_CONTROL;
    serialNumenerControl = ViewDeceasedDetailsCmConstant.SERIAL_NUMBER_CONTROL;
    verticalPositionControl = ViewDeceasedDetailsCmConstant.VERTICAL_POSITION_CONTROL;
    undertakerControl = ViewDeceasedDetailsCmConstant.NAME_OF_THE_UNDERTAKER_CONTROL;
    validationMessages = ViewDeceasedDetailsCmConstant.VALIDATION_MESSAGES;
    title = ViewDeceasedDetailsCmConstant.DECEASED_DETAILS_TITLE;
    sexPh = ViewDeceasedDetailsCmConstant.SEX_PH;
    nationalityPh = ViewDeceasedDetailsCmConstant.NATIONALITY_PH;
    provinceOfDeathPh = ViewDeceasedDetailsCmConstant.PROVINCE_OF_DEATH_PH;
    identityTypePh = ViewDeceasedDetailsCmConstant.IDENTITY_TYPE_PH;
    verticalPositionPh = ViewDeceasedDetailsCmConstant.VERTICAL_POSITION_PH;
    deceasedForm;
    tableHeader = DeceasedNamesTableHeaderLookup;
    nationalityLookup = LookupConstants.COUNTRIES;
    tableLabel = ViewDeceasedDetailsCmConstant.TABLE_LABEL;
    provinceLookup = LookupConstants.PROVINCE;
    identificationTypeLookup = [];
    sexLookup = [];
    verticalPositionLookup = [];
    deceasedNameList;
    deceasedNameListObservable;
    lookupConst = {
        IdentificationType: "IDType",
        Sex: "Sex",
        VerticalPosition: "VerticalPosition",
    };
    getLookupsObservableSubscription;
    getApplicationsSubscription;
    constructor(applicationViewService, appController, changeDetectorRefs, aflaModuleStrategyService, datePipe, selectedApplicationService, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.datePipe = datePipe;
        this.selectedApplicationService = selectedApplicationService;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.loadLookups();
        this.listenForRouteParamChange();
    }
    loadMetadata(stepMeta) {
    }
    handleRouteChange() {
    }
    populateForm(application) {
        if (application.deceased.length > 0) {
            application.deceased.forEach((deceased) => {
                this.deceasedForm.get(this.sexControl).setValue(deceased.sex);
                this.deceasedForm.get(this.nationalityControl).disable();
                this.deceasedForm.get(this.nationalityControl).setValue(deceased.nationality);
                this.deceasedForm.get(this.maidenNameControl).disable();
                this.deceasedForm.get(this.maidenNameControl).setValue(deceased.maidenName);
                this.deceasedForm.get(this.placeOfBirthControl).disable();
                this.deceasedForm.get(this.placeOfBirthControl).setValue(deceased.placeOfBirth);
                this.deceasedForm.get(this.placeOfDeathControl).disable();
                this.deceasedForm.get(this.placeOfDeathControl).setValue(deceased.placeOfDeath);
                this.deceasedForm.get(this.provinceOfDeathControl).disable();
                this.deceasedForm.get(this.provinceOfDeathControl).setValue(deceased.provinceOfDeath);
                this.deceasedForm.get(this.identificationTypeControl).disable();
                this.deceasedForm.get(this.identificationTypeControl).setValue(deceased.idType);
                this.deceasedForm.get(this.idNumberControl).disable();
                this.deceasedForm.get(this.idNumberControl).setValue(deceased.idNumber);
                this.deceasedForm.get(this.dateOfBirthControl).setValue(this.datePipe.transform(deceased.dateOfBirth, "yyyy-MM-dd)"));
                this.deceasedForm.get(this.dateOfBirthControl).disable();
                this.deceasedForm.get(this.dateOfDeathControl).setValue(this.datePipe.transform(deceased.dateOfDeath, "yyyy-MM-dd"));
                this.deceasedForm.get(this.dateOfDeathControl).disable();
                this.deceasedForm.get(this.burialOrderNumberControl).disable();
                this.deceasedForm.get(this.burialOrderNumberControl).setValue(deceased.burialOrderNumber);
                this.deceasedForm.get(this.serialNumenerControl).disable();
                this.deceasedForm.get(this.serialNumenerControl).setValue(deceased.serialNo);
                this.deceasedForm.get(this.verticalPositionControl).disable();
                this.deceasedForm.get(this.verticalPositionControl).setValue(deceased.verticalPosition);
                this.deceasedForm.get(this.undertakerControl).disable();
                this.deceasedForm.get(this.undertakerControl).setValue(deceased.undertaker);
                if (deceased.deceasedNames && deceased.deceasedNames.length > 0) {
                    this.deceasedForm.get("deceasedNames").setValue(deceased.deceasedNames);
                    this.deceasedNameList = deceased.deceasedNames;
                    this.intDataSource();
                    this.changeDetectorRefs.detectChanges();
                }
            });
        }
    }
    initForm() {
        this.deceasedForm = this.aflaModuleStrategyService.form.get("deceasedForm");
    }
    loadLookups() {
        this.getLookupsObservableSubscription =
            this.applicationViewService.getLookupsObservable({
                $filter: `moduleId eq ${this.appController.selectedModuleID} and name in ('${this.lookupConst.IdentificationType}','${this.lookupConst.Sex}','${this.lookupConst.VerticalPosition}') and deleted eq false`,
            })
                .subscribe((lookupValues) => {
                const lookup = lookupValues.value;
                lookup.forEach((lp) => {
                    if (lp.name === this.lookupConst.IdentificationType)
                        this.identificationTypeLookup.push(JSON.parse(lp.content));
                    if (lp.name === this.lookupConst.Sex)
                        this.sexLookup.push(JSON.parse(lp.content));
                    if (lp.name === this.lookupConst.VerticalPosition)
                        this.verticalPositionLookup.push(JSON.parse(lp.content));
                });
                this.getApplicationDeceasedDetails(this.selectedApplication);
                this.changeDetectorRefs.detectChanges();
            });
    }
    intDataSource() {
        this.deceasedNameListObservable = of(this.deceasedNameList)
            .pipe(map((resp) => {
            const sch = [];
            resp.forEach(el => {
                sch.push({
                    id: el.id,
                    name: el.name,
                    surname: el.surname,
                    startDate: this.datePipe.transform(el.startDate, ViewDeceasedDetailsCmConstant.SHORT_DATE_CONST)
                });
            });
            return sch;
        }));
    }
    getApplicationDeceasedDetails(savedApplication) {
        const params = {
            $expand: "deceased($expand=deceasedNames)",
            $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${savedApplication.moduleId} and deleted eq false`
        };
        this.getApplicationsSubscription = this.aflaModuleStrategyService.getApplicationsQuery(params).subscribe({
            next: (application) => {
                const updatedApplication = application.value;
                if (updatedApplication.length > 0) {
                    this.populateForm(updatedApplication[0]);
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: AflaModuleStrategyService },
        { type: DatePipe },
        { type: SelectedApplicationService },
        { type: RouterParamsService }
    ];
};
ViewDeceasedDetailsCmComponent = __decorate([
    Component({
        selector: "app-view-deceased-details-cm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewDeceasedDetailsCmComponent);
export { ViewDeceasedDetailsCmComponent };
